import Chart from 'chart.js';
class chart {

    constructor() {
        this.colors = [
            "#7367F0", "#28C76F", "#EA5455", "#0aa699", "#1f3853", "#0090d9",
            "#f35958", "#003f5c", "#58508d", "#bc5090", "#ff6361", "#fbb05e"
        ];
    }

    create(label, usage, height = false, option = false) {
        this.clear(height);
        var ctx = $('#chart');
        let colors = [];
        label.forEach(val => {
            colors.push(this.colors[Math.floor(Math.random() * this.colors.length)]);
        })
        let opt = (option) ? option : { legend: { display: 0 } };
        new Chart(ctx, {
            type: 'bar',
            data: {
                labels: label,
                datasets: [{
                    data: usage,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 1
                }]
            },
            options: opt
        });
    }

    clear(height) {
        $('#chart').remove();
        let h = (height) ? `height="${height}"` : '';
        var chart = `<canvas id="chart" ${h}></canvas>`;
        $('.chart-container').append(chart);
    }

    clearLineChart(height) {
        $('#lineChart').remove();
        let h = (height) ? `height="${height}"` : '';
        var chart = `<canvas id="lineChart" ${h}></canvas>`;
        $('.line-chart-container').append(chart);
    }

    lineChart(label, usage, height = false, option = false) {
        this.clearLineChart(height);
        var line = $('#lineChart');

        let opt = (option) ? option : { legend: { display: 0 } };

        var config = {
            type: 'line',
            data: {
                labels: label,
                datasets: usage
            },
            options: opt
        };
        new Chart(line, config);
    }
}

let app = new chart;
export default app;
